import { LoadingOutlined } from '@ant-design/icons';
import { Row, Spin } from 'antd';
import React from 'react';
import '../../index.css'; // Import custom styles for the spinne

const LoadingSpinner = () => {
    return (
        <Row justify="center" align="middle" style={{ marginTop: "7rem"}}>
        <Spin indicator={<LoadingOutlined className='custom-spinner-icon' spin />} />
      </Row>
    );
}

export default LoadingSpinner;
